var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModuleUrology from '../../schemas/module-urology.json';
var ModuleValueUrology = (function (_super) {
    __extends(ModuleValueUrology, _super);
    function ModuleValueUrology() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueUrology;
}(ModuleValueUniversal));
var SchemaModuleUrology = (function (_super) {
    __extends(SchemaModuleUrology, _super);
    function SchemaModuleUrology() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleUrology);
        return _this;
    }
    SchemaModuleUrology.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
        this.listenValue(['discharge_date_prostatectomy', 'date_of_surgery'], this.fieldHandlerDischargeDate('length_of_stay_prostatectomy').bind(this));
        // If surgical_approach_prostatectomy is selected (any value)
        // then fields nerve_sparing_prostatectomy and retzius_sparing_prostatectomy are required
        // this.listenValue( 'surgical_approach_prostatectomy', ( value: string ) => {
        //   this.schema.properties.nerve_sparing_prostatectomy.required = !value;
        //   this.schema.properties.retzius_sparing_prostatectomy.required = !value;
        // });
    };
    SchemaModuleUrology.prototype.setupValidators = function () {
        _super.prototype.setupValidators.call(this);
        this.validatorDateComparison('discharge_date_prostatectomy', 'date_of_surgery', '>=');
        this.validatorDateComparison('follow_up_prostatectomy', 'date_of_surgery', '>=');
        this.validatorDateComparison('date_of_surgery', 'date_of_birth', '>=');
        this.addValidator('serum_psa_radical_prostatectomy', function (value, formProperty, form) {
            if (value === null || value === undefined) {
                return []; // Allow empty values
            }
            var regex = /^\d+(\.\d)?$/;
            return regex.test(value) ? [] : [{
                    code: 'invalidNumber',
                    path: "#/" + formProperty.path,
                    message: 'Serum PSA must be a number with at most one decimal place.'
                }];
        });
    };
    return SchemaModuleUrology;
}(SchemaModuleUniversal));
export { SchemaModuleUrology };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-urology.ts.pre-build-optimizer.js